import React, { useRef, useEffect, useState } from "react";
import {
  Box,
  Rating,
  Typography,
  Grid,
  Item,
  Divider,
  Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import HeadingComponent from "../../../component/atom/Headings/Heading";
import {
  DashboardStudentCard,
  ForumCard,
  LiveClassCard,
  CourseWalkthroughModal,
} from "../../../component/molecule";
import { Actions } from "../../../core/modules/Actions";
import { connect, useDispatch } from "react-redux";
import { IMAGE_URL, EXISTING_COURSE_STATUS, DEFAULT_CURRENCY } from "../../../core/Constant";
import { useTheme } from "@mui/material/styles";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import MobileStepper from "@mui/material/MobileStepper";
import moment from "moment";
import _ from "lodash";
import { IMAGES } from "../../../assets/Images";
import SwipeableViews from "react-swipeable-views";
import { makeStyles } from "@material-ui/core";
import DashboardForumCard from "../../../component/molecule/Cards/DashboardForumCard";

const useStyles = makeStyles({
  root: {
    maxWidth: 400,
    flexGrow: 1,
    backgroundColor: "transparent",
  },
  dot: {
    backgroundColor: "#00FFFFFF",
  },
  dotActive: {
    backgroundColor: "#00FFFFFF",
  },
});

const DashboardScreen = ({
  userDashboardData,
  userDashboard,
  getcourseProgress,
  getLiveWebinar,
  courseprogress,
  verifyToken,
  liveWebinar,
}) => {
  const navigate = useNavigate();
  // const intervalRef = useRef(null);
  const theme = useTheme();
  const [value, setValue] = React.useState(2);
  const [forumData, setForumData] = useState([]);
  const [progress, setProgress] = useState([]);
  const [livewebinar, setLiveWebinar] = useState([]);
  const [activeStep, setActiveStep] = useState(0);
  const [maxsteps, setMaxSteps] = useState(0);
  const classes = useStyles();
  const dispatch = useDispatch();

  

  const cropText = (inputText, maxLength) => {
    if (inputText.length > maxLength) {
      return inputText.slice(0, maxLength) + "...";
    } else {
      return inputText;
    }
  };

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStepChange = (step) => {
    setActiveStep(step);
  };

  useEffect(() => {
    userDashboard({ dashboard: 1 });
    getcourseProgress();
    getLiveWebinar();
  }, [navigate]);

  useEffect(() => {
    // const result = _.map(userDashboardData.forums, ({ forums }) => ({forums }));
    //console.log(result)
    setForumData(userDashboardData);
    setProgress(courseprogress);
    setLiveWebinar(liveWebinar);
    setMaxSteps(progress.length);
    console.log(userDashboardData,'dataaaaaaa')
  }, [forumData, courseprogress, progress, liveWebinar]);

  useEffect(() => { }, [progress]);

  const onViewForum = (item) => {
    // 👇️ navigate to /contacts
    navigate("/forum-message", {
      state: { forumId: _.get(item, "id", ""), forum: item },
    });
  };

  const navigateToCourseDetails = (params) => {
    navigate("/course-details", {
      state: params,
    });
  };

  
  return (
    <>
    <div
      className="main-screen-container"
      style={{
        width: "100%",
        minWidth: 0,
        boxSizing: "border-box",
        overflowX: "hidden",
      }}
    >
      <Grid container flexDirection={"column"} rowGap={4}>
        <Grid item>
          <Grid container flexDirection={"column"}>
            <Grid item>
              <Box>
                <img
                  src={IMAGES.welcomeText}
                  alt="Welcome-text"
                  style={{
                    objectFit: "cover",
                    height: "auto",
                    maxWidth: "100%",
                    width: 400,
                    alignSelf: "center",
                    display: "block",
                  }}
                />
              </Box>
            </Grid>
            <Grid item>
              <HeadingComponent
                fontfamily={"Montserrat"}
                size={16}
                color={"#4e657c"}
                text={
                  "Navigating Excellence: Your Learning Adventure at Winspert"
                }
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Grid
            container
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "minmax(0, 1fr)",
                md: "repeat(2, minmax(0, 1fr))",
                lg: "repeat(3, minmax(0, 1fr))",
              },
              gap: 2,
              width: "100%",
              minWidth: 0,
              gridAutoRows: "1fr",
              alignItems: "stretch",
            }}
          >
            <Grid item sx={{ minWidth: 0, width: "100%", height: "100%", boxSizing: "border-box" }}>
              <div
                style={{
                  padding: "clamp(8px, 2vw, 20px)",
                  width: "100%",
                  minWidth: 0,
                  height: "100%",
                  display: "flex",
                  boxSizing: "border-box",
                  background:
                    "repeating-linear-gradient(45deg, #bd8aead9, #782abcd9 140px, white 140px, white 80px)",
                  boxShadow: "#7b52d959 0px 0px 5px 0.25rem",
                  borderRadius: "10px"
                }}
              >

                <Box sx={{ backgroundColor: "#ffffff", width: "100%", height: "100%", borderRadius: "10px" }}>
                    <DashboardStudentCard
                      onButtonClick={(params) =>
                        navigateToCourseDetails(params)
                      }
                      list={progress}
                    />
                  </Box>
              </div>
            </Grid>
            <Grid item sx={{ minWidth: 0, width: "100%", height: "100%", boxSizing: "border-box" }}>
              <div
                style={{
                  padding: "clamp(8px, 2vw, 20px)",
                  width: "100%",
                  minWidth: 0,
                  height: "100%",
                  display: "flex",
                  boxSizing: "border-box",
                  background:
                    "repeating-linear-gradient(45deg, #bd8aead9, #782abcd9 140px, white 140px, white 80px)",
                  boxShadow: "#7b52d959 0px 0px 5px 0.25rem",
                  borderRadius: "10px"
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                    width: "100%",
                    height: "100%",
                    borderRadius: "10px"
                  }}
                >
                  <Box sx={{ backgroundColor: "#ffffff", width: "100%", height: "100%", borderRadius: "10px" }}>
                    <DashboardForumCard list={userDashboardData} />
                  </Box>
                </Box>
              </div>
            </Grid>
            <Grid item sx={{ minWidth: 0, width: "100%", height: "100%", boxSizing: "border-box" }}>
              <div
                style={{
                  padding: "clamp(8px, 2vw, 20px)",
                  width: "100%",
                  minWidth: 0,
                  height: "100%",
                  display: "flex",
                  boxSizing: "border-box",
                  background:
                    "repeating-linear-gradient(45deg, #bd8aead9, #782abcd9 140px, white 140px, white 80px)",
                  boxShadow: "#7b52d959 0px 0px 5px 0.25rem",
                  borderRadius: "10px"
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                    width: "100%",
                    height: "100%",
                  }}
                >
                                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                    width: "100%",
                    height: "100%",
                    borderRadius: "10px"
                  }}
                >
                  <Box sx={{ backgroundColor: "#ffffff", width: "100%", height: "100%", borderRadius: "10px" }}>
                    <LiveClassCard list={livewebinar} />
                  </Box>
                </Box>
                </Box>
              </div>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
    </>
  );
};

export default connect(
  (state) => ({
    userDashboardData: state.home.get("userDashboardData"),
    courseprogress: state.home.get("courseprogress"),
    liveWebinar: state.home.get("liveWebinar"),
  }),
  {
    userDashboard: Actions.home.userDashboard,
    getcourseProgress: Actions.home.getcourseProgress,
    verifyToken: Actions.auth.verifyToken,
    getLiveWebinar: Actions.home.getLiveWebinar,
  }
)(DashboardScreen);
 